import { DiscountCodeGenerator } from '@/components/DiscountCodeGenerator';
import { BxgyDiscountGenerator } from '@/components/BxgyDiscountGenerator';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const AdminDiscounts = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <h1 className="text-4xl font-bold mb-2">Rabattkode Administrasjon</h1>
            <p className="text-muted-foreground">
              Opprett engangskoder for Shopify som kun kan brukes 1 gang totalt
            </p>
          </div>
          
          <DiscountCodeGenerator />
          
          <div className="mt-12">
            <BxgyDiscountGenerator />
          </div>
          
          <div className="mt-8 p-6 bg-muted/50 rounded-lg">
            <h2 className="font-semibold mb-3 text-lg">💡 Forslag til koder:</h2>
            <ul className="space-y-2 text-sm">
              <li><strong>BEKLAG200</strong> - Kort og tydelig beklagelse</li>
              <li><strong>SENLEVERINGUNNSKYLD</strong> - Forklarer årsaken</li>
              <li><strong>SORRY200</strong> - Enkel engelsk variant</li>
              <li><strong>KOMPENSASJON200</strong> - Profesjonell tone</li>
            </ul>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AdminDiscounts;
